"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Column;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
const offsets = sizes.map(size => 'offset' + size[0].toUpperCase() + size[1]);
const pulls = sizes.map(size => 'pull' + size[0].toUpperCase() + size[1]);
const pushes = sizes.map(size => 'push' + size[0].toUpperCase() + size[1]);
function Column(props) {
  const classes = [];
  sizes.forEach(size => {
    if (props[size]) {
      classes.push('col-' + size + '-' + props[size]);
    }
  });
  offsets.forEach((offset, i) => {
    if (props[offset]) {
      classes.push('col-' + sizes[i] + '-offset-' + props[offset]);
    }
  });
  pushes.forEach((push, i) => {
    if (props[push]) {
      classes.push('col-' + sizes[i] + '-push-' + props[push]);
    }
  });
  pulls.forEach((pull, i) => {
    if (props[pull]) {
      classes.push('col-' + sizes[i] + '-pull-' + props[pull]);
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": props['data-test-id'],
    className: classes.join(' ')
  }, props.children);
}